import { Auth } from 'aws-amplify';

export function completeNewPasswordAPI(confirmNewPasswordData) {
  return Auth.completeNewPassword(confirmNewPasswordData.user, confirmNewPasswordData.newPassword);
}
